import React from 'react';
import PropTypes from 'prop-types';

export const RandomTrainRecommend = ({ trainName, trainNumber, trainPageUrl, idx }) => (
  <li key={`train_${idx}`} className="appendBottom10">
    <a href={trainPageUrl} className="font14 darkGreyText railSeoWrap__rwStnListLink">
      <span className="latoBold font14 blackText">{trainNumber}</span>
      {trainName}
    </a>
  </li>
);

RandomTrainRecommend.propTypes = {
  trainName: PropTypes.string,
  trainNumber: PropTypes.string,
  idx: PropTypes.number,
  trainPageUrl: PropTypes.string
};
export default RandomTrainRecommend;
